export default __webpack_public_path__ + "static/media/dino_mark.a7e5fca1.png";